/* MaxPrint — WhatsApp lead attribution.
   Captures the Google click id on landing and stamps it into every WhatsApp
   message the visitor sends TO US, so a quote given on WhatsApp can be matched
   back to the ad click and uploaded to Google Ads as an offline conversion.

   Two rules that matter:
   1. Only links addressed to a MaxPrint number are stamped. "Share with a
      friend" links (wa.me/?text=... with no phone) are left alone — otherwise
      the friend's message would carry someone else's click id.
   2. WhatsApp does not decode "+" as a space, so the text parameter must be
      encoded with encodeURIComponent (%20), never via URLSearchParams. */
(function () {
  var KEY = 'mx_click_ref';
  var MAX_AGE = 90 * 24 * 60 * 60 * 1000; /* Google's click lookback window */
  var LABEL = '\n\nرقم المرجع / Ref: ';

  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  function capture() {
    var id = param('gclid') || param('gbraid') || param('wbraid');
    if (!id) return;
    try { localStorage.setItem(KEY, JSON.stringify({ id: id, t: Date.now() })); }
    catch (e) {}
  }

  function currentRef() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return '';
      var o = JSON.parse(raw);
      if (!o || !o.id) return '';
      if (Date.now() - (o.t || 0) > MAX_AGE) { localStorage.removeItem(KEY); return ''; }
      return String(o.id);
    } catch (e) { return ''; }
  }

  /* true only when the link opens a chat with a specific number (ours) */
  function isChatWithUs(href) {
    if (/^(https?:)?\/\/(www\.)?wa\.me\/\d{8,}/i.test(href)) return true;
    if (/^(https?:)?\/\/(api|web|www)?\.?whatsapp\.com\/send/i.test(href) &&
        /[?&]phone=\d{8,}/i.test(href)) return true;
    return false;
  }

  function readText(href) {
    var m = href.match(/[?&]text=([^&#]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, '%20')); }
    catch (e) { return ''; }
  }

  function writeText(href, text) {
    var enc = encodeURIComponent(text);
    if (/[?&]text=/.test(href)) return href.replace(/([?&]text=)[^&#]*/, '$1' + enc);
    return href + (href.indexOf('?') > -1 ? '&' : '?') + 'text=' + enc;
  }

  function decorate(a) {
    if (!a || a.getAttribute('data-mx-ref') === '1') return;
    var href = a.getAttribute('href') || '';
    if (!href || !isChatWithUs(href)) return;
    var ref = currentRef();
    if (!ref) return;
    var text = readText(href);
    if (text.indexOf(ref) > -1) { a.setAttribute('data-mx-ref', '1'); return; }
    a.setAttribute('href', writeText(href, text + LABEL + ref));
    a.setAttribute('data-mx-ref', '1');
  }

  function decorateAll() {
    var links = document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]');
    for (var i = 0; i < links.length; i++) decorate(links[i]);
  }

  capture();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll);
  } else {
    decorateAll();
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== document) {
      if (el.tagName === 'A') { decorate(el); break; }
      el = el.parentNode;
    }
  }, true);

  if (window.MutationObserver) {
    try {
      new MutationObserver(function () { decorateAll(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
})();